module.exports = __webpack_public_path__ + "img/R6__1242.f2752500.jpeg";